export const routes = {
    articles: 'articles',
    buttonSettings: 'button-settings',
    cart: 'cart',
    customizations: 'customizations',
    fonts: 'fonts',
    individualization: 'individualization',
    individualizationToggle: 'individualization-toggle',
    media: 'media',
    mediaCategories: 'media-categories',
    mediaCategoriesAndCount: 'media-categories-count',
    orders: 'orders',
    plugin: 'plugin',
    server: 'server',
    subscription: 'subscription',
    surchargeArticles: 'surcharge-articles',
    updateSubscription: 'update-subscription'
} as const

